import _ from 'lodash';
import {
  STRIPE_CARD_LOADING,
  STRIPE_CARD_SUCCESS,
  STRIPE_CARD_ERROR,
  STRIPE_CARD_EDIT_LOADING,
  STRIPE_CARD_EDIT_ERROR,
  STRIPE_CARD_ADD,
  STRIPE_CARD_REMOVE,
  STRIPE_CARD_SET_DEFAULT
} from '../actions/stripeCardActions';

const INITIAL_STATE = {};

export default function stripeCardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case STRIPE_CARD_LOADING:
      return { ...state, status: 'loading' };

    case STRIPE_CARD_SUCCESS:
      return { data: action.payload };

    case STRIPE_CARD_ERROR: {
      const { status, statusText } = action.payload.response;
      const { message } = action.payload;

      return { error: { status, statusText, message } };
    }

    case STRIPE_CARD_EDIT_LOADING:
      return { ...state, edit_status: 'loading', edit_error: null };

    case STRIPE_CARD_EDIT_ERROR: {
      const { message } = action.payload.error;
      return { ...state, edit_status: 'fail', edit_error: message };
    }

    case STRIPE_CARD_ADD:
      return {
        edit_status: 'success',
        data: state.data ? [...state.data, action.payload] : [action.payload]
      };

    case STRIPE_CARD_REMOVE:
      return { edit_status: 'success', data: _.reject(state.data, { id: action.payload.id }) };

    case STRIPE_CARD_SET_DEFAULT:
      return { edit_status: 'success', data: [...state.data] };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stripeCardReducer.js